import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'qpoint-toolbar-button-wrapper',
  templateUrl: './toolbar-button-wrapper.component.html',
  styleUrls: ['./toolbar-button-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true
})
export class QPointToolbarButtonWrapperComponent {
}
